import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {logout} from '../../../actions';
import {logout as logoutApi } from '../../../gateways/authentication'
import { connect } from 'react-redux';
import { Jumbotron } from 'reactstrap';

class Logout extends Component {

  constructor(props) {
    super(props)
    this.state = {
        loggedOut: false
    };
  }

  logoutHandler() {
    let self = this;
    if ( this.state.loggedOut ) {
      return (
        <Redirect to="/login"/>
      );
    } else {
      logoutApi()
      .then((result) => {
        if ( !result.error ) {
          this.props.logout();
          this.setState({'loggedOut': true});
        }
      });
      return (
        <Jumbotron>
          <h2>We're logging you out from the system...</h2>
        </Jumbotron>
      )
    }
  }

  render() {
    return (
      this.logoutHandler()
    )
  }
}

export default connect(null, {logout})(Logout);




// WEBPACK FOOTER //
// ./src/views/Pages/Logout/Logout.js